import { Button } from "@mantine/core";
import { useStore } from "@/store";
import { IconPlayerPlayFilled } from "@tabler/icons-react";
import { SUPPORT_VIDEOS } from "@/configs/supportVideos";
import { ButtonProps } from "../ui/Button";

export function SupportVideoButton(props: {
  supportVideoId: string;
  shouldShowTitle?: boolean;
  title?: string;
  buttonProps?: ButtonProps;
}) {
  const setActiveSupportVideoId = useStore(
    (state) => state.support.setActiveSupportVideoId,
  );

  const activeSupportVideoConfig = props.supportVideoId
    ? SUPPORT_VIDEOS[props.supportVideoId as keyof typeof SUPPORT_VIDEOS]
    : null;

  return (
    <Button
      variant="transparent"
      color="primary"
      size="xs"
      opacity={0.75}
      leftSection={<IconPlayerPlayFilled size={16} />}
      onClick={() => setActiveSupportVideoId(props.supportVideoId)}
      {...props.buttonProps}
    >
      {props.shouldShowTitle
        ? props.title || activeSupportVideoConfig?.title
        : "Learn more"}
    </Button>
  );
}
